import { ContextlessQueryObserverOptions } from '@frontend/react-query-helpers';

export const defaultOptions: ContextlessQueryObserverOptions = {
  refetchOnWindowFocus: false,
};
